import React, { Component } from 'react';
import { Form, Message, Loader } from 'semantic-ui-react';
import './ContactForm.css';

import Recaptcha from 'react-recaptcha';
import qs from 'qs';
import axios from 'axios';

class ContactForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            nameError: false,
            email: '',
            emailError: false,
            message: '',
            messageError: false,
            formError: false,
            formComplete: false,
            captcha: '',
            captchaError: false,
            sending: false,
            sent: false,
        };

        this.submitForm = this.submitForm.bind(this);
    }

    onChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    validateEmail = email => {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    validation = () => {
        let error = false;

        // Name
        if (this.state.name === '') {
            this.setState({ nameError: true });
            error = true;
        } else {
            this.setState({ nameError: false });
        }

        // Email
        if (this.state.email === '' || !this.validateEmail(this.state.email)) {
            this.setState({ emailError: true });
            error = true;
        } else {
            this.setState({ emailError: false });
        }

        // Message
        if (this.state.message === '') {
            this.setState({ messageError: true });
            error = true;
        } else {
            this.setState({ messageError: false });
        }

        // captcha
        if (this.state.captcha === '') {
            this.setState({ captchaError: true });
            error = true;
        } else {
            this.setState({ captchaError: false });
        }

        // Result
        if (error) {
            this.setState({ formError: true });
            return false;
        } else {
            return true;
        }
    };

    submitForm = e => {
        e.preventDefault();
        if (this.validation()) {
            this.setState({
                formError: false,
                formComplete: true,
                sending: true,
            });

            const message = {
                name: this.state.name,
                email: this.state.email,
                message: this.state.message,
                captcha: this.state.captcha,
            };

            // Send message
            axios
                .post('./contact.php', qs.stringify(message))
                .then(response => {
                    if (response.status === 200 && response.data === 'Success') {
                        this.setState({ sent: true });
                    }
                    console.log(response);
                })
                .catch(error => {
                    this.setState({ sent: false });
                    console.log(error);
                })
                .finally(() => {
                    this.setState({ sending: false });
                });
        }
    };

    captchaWerifyCallback = res => {
        this.setState({ captcha: res });
    };

    render() {
        return (
            <div>
                {!this.state.formComplete ? (
                    <Form error={this.state.formError} onSubmit={this.submitForm}>
                        {this.state.formError ? (
                            <Message
                                icon="warning sign"
                                error
                                header="Error"
                                content="Please complete all required fields."
                            />
                        ) : (
                            ''
                        )}
                        <Form.Group widths="equal">
                            <Form.Input
                                fluid
                                label="Name"
                                placeholder="Name"
                                name="name"
                                onChange={e => this.onChange(e)}
                                error={this.state.nameError}
                            />
                            <Form.Input
                                fluid
                                label="Email"
                                placeholder="joe@coolmail.com"
                                name="email"
                                onChange={e => this.onChange(e)}
                                error={this.state.emailError}
                            />
                        </Form.Group>
                        <Form.TextArea
                            label="Message"
                            placeholder="Message..."
                            name="message"
                            onChange={e => this.onChange(e)}
                            error={this.state.messageError}
                        />
                        <Form.Field error={this.state.captchaError || false}>
                            <label>Spam protection</label>
                            <Message error={this.state.captchaError || false}>
                                <Recaptcha
                                    sitekey="6LfBWVMUAAAAACUQogabiUtY4-coJqObwq85Xgex"
                                    render="explicit"
                                    verifyCallback={this.captchaWerifyCallback}
                                />
                            </Message>
                        </Form.Field>
                        <br />
                        <Form.Button>Submit</Form.Button>
                    </Form>
                ) : this.state.sending ? (
                    <Message>
                        <br />
                        <Loader active size="large" inline="centered" content="Sending..." className="loaderFix" />
                        <br />
                    </Message>
                ) : !this.state.sent ? (
                    <Message
                        error
                        icon="send"
                        header={`Error, ${this.state.name}`}
                        content="Your message couldn't be sent. Please try send me mail directly from your mailbox: contact@rafalradomski.com."
                    />
                ) : (
                    <Message
                        success
                        icon="send"
                        header={`Thanks for message, ${this.state.name}`}
                        content="I've received your message and I'll be in touch shortly."
                    />
                )}
            </div>
        );
    }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm.js